import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=e0eb4966&scoped=true&lang=pug&"
import script from "./AccountButton.vue?vue&type=script&lang=ts&"
export * from "./AccountButton.vue?vue&type=script&lang=ts&"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=e0eb4966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0eb4966",
  null
  
)

export default component.exports